import { gql } from "@apollo/client";

export default gql`
  query GetDataForToken($token: String!) {
    getDataForToken(token: $token) {
      data
    }
  }
`;
